import script from "./CommonHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./CommonHistory.vue?vue&type=script&setup=true&lang=js"

import "./CommonHistory.vue?vue&type=style&index=0&id=b18f874c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b18f874c"]])

export default __exports__